import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../favicon.ico';
import Home from './HOME/Home';
// import * as serviceWorker from './serviceWorker';
import * as sw from './sw';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import rootReducer from './HOME/REDUX';

const store = createStore(rootReducer);

ReactDOM.render(
  <Provider store={store}>
    <Home />
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
sw.register();
